require('../project/src/plugins/menuAim');
import VegasUI from '../../../modules/vegas/js/_ui';

function initMegaMenu () {
	let $menu = $(".list-categories"),
		$sub = $('.aside-wrapper-categories-sub'),
		$subImage = $('.aside-wrapper-categories-image'),
		$subThirdLevel = $('.aside-wrapper-categories-third-level');

	$sub.removeClass('show');
	$subThirdLevel.removeClass('show');

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu
	});

	function deactivateSubmenu(row) {
		$(row).find('a').removeClass('active')
	}

	function deactivateThirdLevel(row) {
		$(row).find('a').removeClass('active')
	}

	function activateSubmenu(row) {
		let $row = $(row),
			submenuId = $row.data('id'),
			id = parseInt($row.data('num')),
			$submenu = $("#" + submenuId),
			$link = $row.find('a');

		$link.addClass('active');

		$sub.html('');
		$submenu.addClass('show');

		let tree = getTreeData();

		if (!tree) toggleSubWrapper($sub, 'hide');

		$.each(tree, function () {
			let category = this;

			if (id === 0) toggleSubWrapper($sub, 'hide');

			if (category.id === id) {
				if ('children' in category) {
					toggleSubWrapper($sub, 'show');
					tmpl(category.children, id, $sub, true);

					banner(category.banner || {});
				} else {
					toggleSubWrapper($sub, 'hide');
					toggleSubWrapper($subImage, 'hide');
					$subThirdLevel.removeClass('show');
				}
			}
		});
	}

	function toggleSubWrapper ($elem, action) {
		if (action === 'show') {
			$elem.addClass('show');
		}

		if (action === 'hide') {
			$elem.removeClass('show');
		}
	}

	function banner(banner) {
		if (!Object.keys(banner).length) {
			toggleSubWrapper($subImage, 'hide');
			return;
		}

		if ('src' in banner) {
			$subImage.find('.image-area img').attr('src', banner.src);
		}

		if ('title' in banner) {
			$subImage.find('.title-area a').html(banner.title);
		}

		if ('link' in banner) {
			$subImage.find('.title-area a').attr('href', banner.link);
			$subImage.find('.image-area a').attr('href', banner.link);
		}

		toggleSubWrapper($subImage, 'show');
	}

	function tmpl(categories, id, sub, isThirdLevel = false) {
		let ul = document.createElement('ul');
		ul.classList.add('list');
		ul.classList.add('list-column');
		ul.classList.add('list-categories');
		ul.setAttribute('id', 'sub-category-' + id);

		let wrapper = document.createElement('div');
		wrapper.setAttribute('data-scrollbar', 'true');
		wrapper.classList.add('categories-first')

		$.each(categories, function () {
			let category = this,
				li = document.createElement('li');

			let categoryData = getTreeData(category.id);

			li.classList.add('list-item');
			li.setAttribute('data-id', categoryData.id)

			let a = document.createElement('a');
			a.setAttribute('href', category.url);

			let span = document.createElement('span');
			span.classList.add('title')
			span.innerText = category.title;
			a.append(span);

			if (categoryData && 'children' in categoryData) {
				let span = document.createElement('span');
				span.classList.add('toggle')
				span.innerHTML = '<i class="fa fa-chevron-right"></i>';
				a.append(span);

				a.setAttribute('href', categoryData.url);
			}

			li.append(a);
			ul.append(li);
		});

		wrapper.append(ul);
		sub.append(wrapper);

		VegasUI.scrollbar([wrapper], {
			alwaysShowTracks: true
		})

		if (isThirdLevel) {
			$(ul).menuAim({
				activate: activateThirdLevel,
				deactivate: deactivateThirdLevel
			});
		}
	}

	function getTreeData(id = null) {
		function search(value, arr){
			for (let i=0; i < arr.length; i++) {
				if (arr[i].id === value) {
					return arr[i];
				}
			}
		}

		let tree = JSON.parse($("#aside-categories-tree").text());

		if (id) {
			return search(id, tree) || {};
		} else {
			return tree || {};
		}
	}

	function activateThirdLevel(row) {
		let $row = $(row),
			id = parseInt($row.data('id')),
			$link = $row.find('a');

		$link.addClass('active');

		$subThirdLevel.removeClass('show');

		if (id) {
			let categoryData = getTreeData(id);

			if ('children' in categoryData) {
				$subThirdLevel.addClass('show');
				$subThirdLevel.html('')
				tmpl(categoryData.children, id, $subThirdLevel);
			}
		}
	}

	return false;
}

let currentElem = null,
	aside = document.querySelector('.aside'),
	btn = document.querySelector('[data-toggle="vg-dropdown-side"]'),
	headerTop = document.querySelector('.header-top'),
	headerCenter = document.querySelector('.header-center'),
	headerBottom = document.querySelector('.header-bottom'),
	isHover = btn.dataset.hover === 'true' || false;

if (btn && aside) {
	let aWrapper = aside.querySelector('.aside-wrapper');

	console.log(isHover)

	if (isHover) {
		btn.addEventListener('mouseover', function (event) {
			if (currentElem) return;

			if (!aside) return;

			showAside();
			currentElem = aWrapper;
		});

		btn.addEventListener('mouseout', function (event) {
			if (!currentElem) return;

			let relatedTarget = event.relatedTarget;

			while (relatedTarget) {
				if (relatedTarget === currentElem) return;
				relatedTarget = relatedTarget.parentNode;
			}

			currentElem = null;
			hideAside();
		});

		aWrapper.addEventListener('mouseout', function (event) {
			if (!currentElem) return;

			let relatedTarget = event.relatedTarget;

			while (relatedTarget) {
				if (relatedTarget === currentElem) return;
				relatedTarget = relatedTarget.parentNode;
			}

			currentElem = null;
			hideAside();
		});
	} else {
		btn.addEventListener('click', function (event ) {
			event.preventDefault();

			if (aside.classList.contains('show')) {
				hideAside();
			} else {
				showAside();
			}
		});
	}

	document.addEventListener('click', function (event) {
		if (!event.target.closest('[data-toggle="vg-dropdown-side"]')) {
			if (!event.target.closest('.aside-wrapper')) hideAside();
		}
	})

	function showAside() {
		let indent = (window.innerWidth - document.documentElement.clientWidth) + 'px';

		aside.classList.add('show');
		document.body.style.paddingRight = indent;
		document.body.style.overflow = "hidden";
		document.body.classList.add('aside-open');

		btn.querySelector('i').classList.remove('icon-bars');
		btn.querySelector('i').classList.add('icon-cross');

		initMegaMenu();

		if (headerBottom) headerBottom.style.paddingRight = indent;
		if (headerCenter) headerCenter.style.paddingRight = indent;
		if (headerTop) headerTop.style.paddingRight = indent;
	}

	function hideAside() {
		aside.classList.remove('show');
		document.body.style.paddingRight = "";
		document.body.style.overflow = "";
		document.body.classList.remove('aside-open');

		btn.querySelector('i').classList.remove('icon-cross');
		btn.querySelector('i').classList.add('icon-bars');

		if (headerBottom) headerBottom.style.paddingRight = '';
		if (headerCenter) headerCenter.style.paddingRight = '';
		if (headerTop) headerTop.style.paddingRight = '';
	}
}
